// @ts-nocheck 847a8a51
import * as actionTypes from './wixAdActionTypes';

const overrideWixAdsBanner = (overrides) => ({
  type: actionTypes.OVERRIDE_WIX_AD,
  overrides,
});

export { overrideWixAdsBanner };
